import { render } from "./BranchTransferOperationExecutiveView.vue?vue&type=template&id=685a9d7f"
import script from "./BranchTransferOperationExecutiveView.vue?vue&type=script&lang=js"
export * from "./BranchTransferOperationExecutiveView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__